import { GET_CONTENT, CONTENT_API_SUCCESS, CONTENT_API_ERROR, SYNC_CONTENTFUL_DATA_SUCCESS, CONTENTFUL_ENTRY_SUCCESS, NAVIGATION_LINK_CONTENT, GET_GUEST_CONTENT_SUCCESS, GET_GUEST_CONTENT_FAILURE, GUEST_CONTENT_CHECKOUT, FIND_A_KFC, FIND_A_KFC_SUCCESS, FIND_A_KFC_ERROR, DYNAMIC_MENU_ALERT_CONTENT, DYNAMIC_MENU_ALERT_SUCCESS, DYNAMIC_MENU_ALERT_ERROR, } from '../../constants';
export const initialState = {
    response: {},
    navigationLinkResponse: {},
    error: false,
    isContentfulLoading: false,
    contentfulSyncData: {},
    isGetGuestDetailsLoading: false,
    guestContentData: {},
    isLoading: false,
    findAKFCContentData: {},
    dynamicMenuAlertData: {},
};
const contentReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CONTENT:
        case NAVIGATION_LINK_CONTENT.GET_CONTENT:
            return {
                ...state,
                isContentfulLoading: true,
            };
        case CONTENT_API_SUCCESS:
            return {
                ...state,
                response: action.response,
                error: false,
                isContentfulLoading: false,
            };
        case CONTENT_API_ERROR:
        case NAVIGATION_LINK_CONTENT.GET_CONTENT_ERROR:
            return {
                ...state,
                error: true,
                isContentfulLoading: false,
            };
        case NAVIGATION_LINK_CONTENT.GET_CONTENT_SUCCESS:
            return {
                ...state,
                isContentfulLoading: false,
                error: false,
                navigationLinkResponse: action.response,
            };
        case SYNC_CONTENTFUL_DATA_SUCCESS:
            return {
                ...state,
                contentfulSyncData: action.response,
            };
        case CONTENTFUL_ENTRY_SUCCESS:
            return {
                ...state,
                response: updateNewEntry(state.response, action.updatedHomeResponse),
            };
        case GUEST_CONTENT_CHECKOUT:
            return {
                ...state,
                isGetGuestDetailsLoading: true,
            };
        case GET_GUEST_CONTENT_SUCCESS:
            return {
                ...state,
                error: false,
                guestContentData: action.response,
                isGetGuestDetailsLoading: false,
            };
        case GET_GUEST_CONTENT_FAILURE:
            return {
                ...state,
                error: true,
                isGetGuestDetailsLoading: false,
            };
        case FIND_A_KFC:
        case DYNAMIC_MENU_ALERT_CONTENT:
            return {
                ...state,
                isLoading: true,
            };
        case FIND_A_KFC_SUCCESS:
            return {
                ...state,
                findAKFCContentData: action.response,
                error: false,
                isLoading: false,
            };
        case FIND_A_KFC_ERROR:
        case DYNAMIC_MENU_ALERT_ERROR:
            return {
                ...state,
                error: true,
                isLoading: false,
            };
        case DYNAMIC_MENU_ALERT_SUCCESS:
            return {
                ...state,
                dynamicMenuAlertData: action.response,
                error: false,
                isLoading: false,
            };
        default:
            return state;
    }
};
export const updateNewEntry = (response, newHomeResponse) => {
    let tempResponse = response;
    if (newHomeResponse?.hasRootChange) {
        tempResponse.homeContentfulResp = newHomeResponse?.newHomeContentfulResp;
        return tempResponse;
    }
    else {
        for (let i = 0; i < newHomeResponse?.homeResponse?.length; i++) {
            const newEntry = newHomeResponse?.homeResponse[i];
            tempResponse.homeContentfulResp[newEntry?.index] = newEntry;
        }
        return tempResponse;
    }
};
export default contentReducer;
